import logo from "assets/images/integrations/brevo_logo.png";
import { useCallback, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { connect, ConnectedProps } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { useOpenFeatureFlag } from "shared/hooks";
import { RootReduxState } from "../../../../../utils/types";
import { AvailableIntegrationCardAddButton } from "../../components/AvailableIntegrationCardAddButton";
import { AvailableIntegrationCardExplanationWrapper } from "../../components/AvailableIntegrationCardExplanationWrapper";
import { AvailableIntegrationCardHeader } from "../../components/AvailableIntegrationCardHeader";
import { AvailableIntegrationCardWrapper } from "../../components/AvailableIntegrationCardWrapper";
import { ConnectViewComponentProps, IntegrationType } from "../../types";
import { BrevoConnectModal } from "./ConnectModal";
import {
  BrevoDataReduxState,
  BrevoRequestReduxState,
  getBrevoIntegrationSettingsAction
} from "./redux";

type BrevoConnectViewComponentOwnProps = ConnectViewComponentProps;

const mapStateToProps = (state: RootReduxState) => {
  const selectedShopId = state.getIn([
    "customerBackendDashboard",
    "userData",
    "selectedShopId"
  ]) as string;

  const getRequestState = state
    .getIn(["integrations", "brevo", "requests", "get"])
    .toJS() as BrevoRequestReduxState;

  return {
    selectedShopId: Number(selectedShopId),
    isLoading: getRequestState.loading,
    integrationData: state.getIn(["integrations", "brevo", "data"])?.toJS() as
      | BrevoDataReduxState
      | undefined
  };
};
const matchDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getBrevoIntegrationSettingsAction
    },
    dispatch
  );
const connector = connect(mapStateToProps, matchDispatchToProps);

type BrevoConnectViewComponentProps = BrevoConnectViewComponentOwnProps &
  ConnectedProps<typeof connector>;

const BrevoConnectViewComponent = (props: BrevoConnectViewComponentProps) => {
  const {
    connectingType,
    onStartConnecting,
    onStopConnecting,
    integrationData,
    getBrevoIntegrationSettingsAction,
    selectedShopId,
    isLoading
  } = props;

  const { value: integrationFeatureFlagEnabled } = useOpenFeatureFlag(
    "brevo_integration_setup_enabled"
  );

  useEffect(() => {
    getBrevoIntegrationSettingsAction(selectedShopId);
  }, []);

  const handleConnect = useCallback(() => {
    onStartConnecting(IntegrationType.BREVO);
  }, [onStartConnecting]);

  const isConnected = integrationData?.settings !== undefined;

  if (!isConnected && !integrationFeatureFlagEnabled) {
    return null;
  }

  return (
    <AvailableIntegrationCardWrapper>
      {connectingType === IntegrationType.BREVO && (
        <BrevoConnectModal handleClose={onStopConnecting} />
      )}
      <AvailableIntegrationCardHeader image={logo} text="Brevo" />
      <AvailableIntegrationCardExplanationWrapper>
        <FormattedMessage
          id="containers.Integrations.ListOfApps.Shared.Short.Explanation"
          defaultMessage="Connect your Brevo account with uptain. Then new newsletter subscribers can be added to your account."
          values={{ tool: "Brevo" }}
        />
      </AvailableIntegrationCardExplanationWrapper>
      <AvailableIntegrationCardAddButton
        isConnected={isConnected}
        loading={isLoading || connectingType !== undefined}
        onConnect={handleConnect}
      />
    </AvailableIntegrationCardWrapper>
  );
};

export const BrevoConnectView = connector(BrevoConnectViewComponent);
